import { createSlice, current } from '@reduxjs/toolkit';

const staticDropdownStore = createSlice({
  name: 'dropdown',
  initialState: {},
  reducers: {
    setDropdown: (state, { payload: { id } }) => {
      const data = current(state);

      if (state[id]) {
        state = { ...state, [id]: !state[id] };
      } else {
        state = { ...state, [id]: true };
      }

      // 다른 dropdown OFF 설정
      for (const key in data) {
        if (key !== id) {
          state[key] = false;
        }
      }

      return state;
    },
  },
});

export const staticDropdownActions = staticDropdownStore.actions;

export default staticDropdownStore.reducer;
